import React, { useState } from 'react'
import Accordeon from '../atoms/Accordeon'

function FaqsFeed({
  faqsType,
  list,
  classType,
}) {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems(prev =>
      prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index]
    )
  }

  return (
    <div className={`mc-faqs-container mc-faqs-container-type-${faqsType}`}>
      {list.map((faq, index) => {
        return (
          <Accordeon
            key={index}
            title={faq.title}
            content={faq.content}
            isOpen={openItems.includes(index)}
            onToggle={() => toggleItem(index)}
            className={classType}
          />
        )
      })}
    </div>
  )
}

export default FaqsFeed